/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import { toast } from "react-toastify";

export default function handleTableError(error) {
    if (error.response) {
        const errorData = Array.isArray(error.response?.data)
            ? error.response?.data[0]
            : error.response?.data;

        // Temporary fix for HTML error responses
        if (typeof errorData === "string") {
            toast.error(
                errorData
                    ? `${error.toString()}: ${errorData.toString()}`
                    : `${error.toString()}`
            );
            return;
        }
        Object.entries(errorData).forEach(([key, value]) =>
            toast.error(`${error.toString()}: ${value.toString()}`)
        );
    } else {
        toast.error(`${error.toString()}: ${error.response?.data.toString()}`);
    }
}
